import { useEffect } from 'react';
import {
  useCreateDrugEventRecordsMutation,
  useLazyGetDARNotesQuery,
  useLazyGetDrugEventRecordsQuery,
  useUpdateDARDocMutation,
  useUpdateDrugEventRecordsMutation
} from 'src/services/DrugAccountability';
import { useCreateDARNotesMutation, useLazyGetAllDespendedQuery } from 'src/services/Overview';
import { useAppDispatch } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { updateUserAccess } from 'src/util/util';

export const useCommonDrugAccountability = () => {
  const dispatch = useAppDispatch();

  const [updateDARDoc, { error: updateDARDocError }] = useUpdateDARDocMutation();

  const [createDARNotes, { error: createDARNotesError }] = useCreateDARNotesMutation();

  const [getDARNotes, { error: getDARNotesError }] = useLazyGetDARNotesQuery();

  const [getDrugEventRecords, { isLoading: getDrugEventRecordsLoading, error: getDrugEventRecordsError }] =
    useLazyGetDrugEventRecordsQuery();

  const [createDrugEventRecords, { error: createDrugEventRecordsError, isSuccess: createDrugEventRecordsSuccess }] =
    useCreateDrugEventRecordsMutation();

  const [updateDrugEventRecords, { error: updateDrugEventRecordsError }] = useUpdateDrugEventRecordsMutation();

  const [getAllDespendedData, { isLoading: allDespendedLoading }] = useLazyGetAllDespendedQuery();

  useEffect(() => {
    if (createDrugEventRecordsSuccess) {
      dispatch(setMessage({ msgDetails: 'Event added Successfully', severity: 'success' }));
    }
  }, [createDrugEventRecordsSuccess]);

  useEffect(() => {
    if (
      updateDARDocError ||
      createDARNotesError ||
      getDARNotesError ||
      getDrugEventRecordsError ||
      createDrugEventRecordsError ||
      updateDrugEventRecordsError
    ) {
      updateUserAccess(
        updateDARDocError ||
          createDARNotesError ||
          getDARNotesError ||
          getDrugEventRecordsError ||
          createDrugEventRecordsError ||
          updateDrugEventRecordsError,
        dispatch
      );
    }
  }, [
    updateDARDocError,
    createDARNotesError,
    getDARNotesError,
    getDrugEventRecordsError,
    createDrugEventRecordsError,
    updateDrugEventRecordsError
  ]);

  return {
    createDARNotes,
    updateDARDoc,
    getDARNotes,
    getDARNotesError,
    getDrugEventRecords,
    getDrugEventRecordsLoading,
    createDrugEventRecords,
    updateDrugEventRecords,
    getAllDespendedData,
    allDespendedLoading,
    createDrugEventRecordsSuccess
  };
};
